var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-muted small mt-1"},[_c('span',{class:{ 'text-danger': _vm.isOverLimit }},[_vm._v(" "+_vm._s(_vm.count)+"/"+_vm._s(_vm.limit)+" "+_vm._s(_vm.label)+" ")]),(_vm.isOverLimit)?_c('span',{staticClass:"text-danger"},[_vm._v(" - "+_vm._s(_vm.$t('limit-exceeded')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }